import {
  ActionsTypes,
  EnumActionsTypesPI,
  IsLoadingInterface,
} from './personalInfo.types';
import { PropertyState, DataPersonInfoState } from '../types/form.types';
import { DataPersonalInfoState } from './personalInfo.state';

export const SetPerson = (payload: DataPersonInfoState): ActionsTypes => ({
  type: EnumActionsTypesPI.SET_PERSON,
  payload,
});

export const SetProperty = (payload: PropertyState): ActionsTypes => ({
  type: EnumActionsTypesPI.SET_DATA_PROPERTY,
  payload,
});

export const fetchRequests = (payload: IsLoadingInterface): ActionsTypes => ({
  type: EnumActionsTypesPI.FETCH_REQUESTS,
  payload: payload,
});

export const fetchFailure = (payload: IsLoadingInterface): ActionsTypes => {
  return {
    type: EnumActionsTypesPI.FETCH_FAILURE,
    payload: payload,
  };
};

export const fetchSuccess = (payload: IsLoadingInterface): ActionsTypes => ({
  type: EnumActionsTypesPI.FETCH_SUCCESS,
  payload: payload,
});

export const backInitialState = (): ActionsTypes => ({
  type: EnumActionsTypesPI.BACK_INITIAL_STATE,
});

export const SetReduxState = (
  payload: DataPersonalInfoState,
): ActionsTypes => ({
  type: EnumActionsTypesPI.SET_REDUX_STATE,
  payload: payload,
});
